import {useGuestGroupMutation as useSharedGuestGroupMutation} from '@chekin/shared/guest-form';
import {useReservation} from 'context/reservation';
import {toastResponseError} from 'utils/common';

export type {GuestGroupMutationError as ErrorRequest} from '@chekin/shared/guest-form';

function useGuestGroupMutation() {
  const {data: reservation} = useReservation();

  return useSharedGuestGroupMutation({
    guestGroupId: reservation?.guest_group_id,
    onValidationError: toastResponseError,
  });
}

export {useGuestGroupMutation};
